// extracted by mini-css-extract-plugin
export var aboveInput = "_j5-0";
export var actionButton = "_j5-5";
export var actionButtonContainer = "_j5-1";
export var actionIcon = "_j5-6";
export var aiInfoContainer = "_j5-2";
export var attachmentWrapper = "_j5-7";
export var bold = "_j5-3";
export var checkIcon = "_j5-8";
export var clickingRecipientBar = "_j5-11";
export var commentThreadSwitch = "_j5-a";
export var draftImage = "_j5-b";
export var draftImageContainer = "_j5-c";
export var draftImages = "_j5-e";
export var editButton = "_j5-g";
export var editor = "_j5-f";
export var editorContainer = "_j5-y";
export var editorErrorTooltipWrapper = "_j5-9";
export var headerDivider = "_j5-h";
export var icon = "_j5-i";
export var info = "_j5-j";
export var internal = "_j5-n";
export var internalDivider = "_j5-k";
export var internalMessage = "_j5-l";
export var messageInputCard = "_j5-m";
export var messageInputForm = "_j5-o";
export var messageInputFormInternal = "_j5-p";
export var options = "_j5-q";
export var publicMessageCustomer = "_j5-s";
export var publicMessageMerchant = "_j5-r";
export var removeImageButton = "_j5-d";
export var replyButtons = "_j5-t";
export var showSignatureButton = "_j5-u";
export var spinner = "_j5-v";
export var verticalButtonDivider = "_j5-4";
export var visibilitySelector = "_j5-w";
export var warning = "_j5-x";
export var wrappingText = "_j5-z";
export var writingInternalNoteTopBorder = "_j5-10";